import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const initialState = {
    isLoading: true,
    isError: false,
    data: {}
};

export const getTitleById = async (id) => {
    let { data } = await axios.request({
        url: `/authorized/titles/${id}`,
        method: 'GET'
    });
    return data;
};

export const saveTitleById = async (id, newData) => {
    let { data } = await axios.request({
        url: `/authorized/titles/${id}`,
        method: 'PATCH',
        data: newData
    });
    return data;
};

export const takedownTitleById = async (id) => {
    let { data } = await axios.request({
        url: `/authorized/titles/${id}/takedown`,
        method: 'POST'
    });
    return data;
};

export const titleSlice = createSlice({
    name: 'title',
    initialState,
    reducers: {
        titleLoading: (state) => {
            state.isLoading = true;
        },
        titleLoadingFailed: (state) => {
            return {
                data: {},
                isError: true,
                isLoading: false
            };
        },
        titleUpdate: (state, action) => {
            state.data = { ...state.data, ...action.payload };
            state.isLoading = false;
        },
        updateAssets: (state, action) => {
            state.data.assets = [...state.data.assets, ...action.payload];
        },
        removeAsset: (state, action) => {
            state.data.assets = state.data.assets.filter((a) => a.id !== action.payload.id);
        },
        titleReset: () => {
            return initialState;
        }
    }
});

export const { titleUpdate, titleLoading, titleLoadingFailed, titleReset, updateAssets, removeAsset } =
    titleSlice.actions;

export default titleSlice.reducer;
